/**
 * Versione dell'applicazione Config Builder
 * Aggiornare questo file ad ogni release
 */
export const APP_VERSION = '1.16.0';
export const APP_NAME = 'Config Builder';
export const APP_COPYRIGHT_YEAR = 2026;
